export const fmt = (v) => (v === null || v === undefined || v === '') ? '—' : v

export const METRICS_TOP = [
  { key: 'overallPerformance',      label: 'Результаты общей успеваемости обучающихся за учебный год (в процентах)' },
  { key: 'studyQuality',            label: 'Качество учебы обучающихся (в процентах)' },
  { key: 'medal1',                  label: 'Количество обучающихся, награжденных медалью "За особые успехи в учении" I степени' },
  { key: 'medal2',                  label: 'Количество обучающихся, награжденных медалью "За особые успехи в учении" II степени' },
  { key: 'conditionallyTransferred', label: 'Количество обучающихся, переведенных в следующий класс условно' },
  { key: 'leftForRepeat',           label: 'Количество оставленных на повторное обучение' },
  { key: 'failedGIA',               label: 'Количество не прошедших ГИА или получивших на итоговой аттестации неудовлетворительные результаты и выпущенных со справкой об обучении' },
]

export const METRICS_MONITORING = [
  { key: 'monitoringTotal',           label: 'Количество обучающихся, привлекаемых к мониторингу (всего)' },
  { key: 'monitoringExcellent',       label: 'Выполнили диагностику на отлично' },
  { key: 'monitoringGood',            label: 'Выполнили диагностику на хорошо' },
  { key: 'monitoringSatisfactory',    label: 'Выполнили диагностику на удовлетворительно' },
  { key: 'monitoringUnsatisfactory',  label: 'Выполнили диагностику на неудовлетворительно' },
  { key: 'monitoringAbsent',          label: 'Количество обучающихся, отсутствовавших на диагностике' },
]

export const MONITORING_SECTION_TITLE = 'Результаты мониторинга (независимой предметной и метапредметной диагностики)'
